import type React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** Markdown an agent wrote (an opportunity's analysis or recommended action), tables included. */
export const Markdown: React.FC<{text: string}> = ({text}) => (
    <div className="ci-markdown">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
    </div>
);
